(function () {
    'use strict';

    function main() {
        const page = wo$('#landing');
        if (!page.length) return;

        const controller = {
            init: function () {
                const productArea = page.data('product-area');
                WhistleOut.getAds(productArea);
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
